'use strict';

require('../modules/forms/forms');
require('../models/ascent/ascentTypes');
require('../models/ascent/ascentUserTypes');
require('../models/mountains/regions');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.ascentEditForm', [
	'dekky.forms',
	'far.models.ascentTypes',
	'far.models.ascentUserTypes',
	'far.models.mountains.regions',
	'far.helpers.showModalMessage'
])
.service('ascentEditForm', function(form, ascentTypes,ascentUserTypes, mountainRegions, autocomplete, fileUploadFilters, showModalMessage) {
	function formFactory() {
		var ascentEditModel = form('ascentEditModel');

		ascentEditModel
			.addField('ascent_date', 'dateDropdowns', {
				validators: { required: false },
				label_before: 'Дата восхождения:',
				label_before_class: 'form__comment'
			})
			.addField('ascent_type', 'selectObject', {
				validators: { required: false },
				options: { defaultOption: 'Способ восхождения' },
				ngOptions: 'item as item.name for item in field.items track by item.id'
			}, ascentTypes.list)
            .addField('ascent_user_type', 'selectObject', {
                validators: { required: true },
                options: {defaultOption: 'Роль'},
                ngOptions: 'item as item.name for item in field.items track by item.id'
            }, ascentUserTypes.list)
			.addField('master_selector', 'radioCollection', {
				validators:{required:false},
				radio:{label: 'name'},
				radioAttributes:{
					ngClick: 'field.ngClick(item, field)'
				},
				fieldData:{
					ngClick: function (item, field) {
						field.radioAttributes.onSelect(item);
                    }
				}
			},[{model:'chief', name:'Руководитель'},{model:'instructor', name:'Инструктор'}])
			.addField('first_ascent', 'checkbox', {
				label: 'Первопрохождение'
			})
			.addField('first_climb', 'checkbox', {
				label: 'Первовосхождение'
			})

			.addField('ascent_mountain_peak', 'mountainPeakSelect')

			.addField('ascent_mountain_route', 'selectObject', {
				validators: {
					required: true
				},
				options: {
					defaultOption: 'Выберите маршрут...',
					onSelect: 'field.uiSelectOptions.onSelect($item)'
				},
                ngOptions: 'item as item.name + " / " +item.mountain_route_complexity.name  for item in field.items track by item.id'
			}, [])
			.addField('user_chief', 'userSelect', {
				uiSelectOptions: {
          match: {
            placeholder: 'Выберите руководителя...'
          },
					choices: {
						refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "users")'
					},
					refreshAutoComplete: autocomplete.refreshAutoComplete
				}
			}, autocomplete.get('users'))
      .addField('user_participant', 'userSelect', {
        uiSelectOptions: {
          match: {
            placeholder: 'Выберите участника...'
          },
          choices: {
            refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userParticipants")'
          },
          refreshAutoComplete: autocomplete.refreshAutoComplete
        }
      }, autocomplete.get('userParticipants'))
            .addField('user_instructor', 'userSelect', {
                uiSelectOptions: {
                    match: {
                        placeholder: 'Выберите инструктора...'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Instructors", "userInstructors")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('userInstructors'))
			.addField('documentsFiles', 'fileUpload', {
				validators: {
					required: false
				},
				label: 'Загрузить документ',
				uploader: {
					url: Routing.generate('api_upload_post_file'),
					autoUpload: true,
					filters: [
						fileUploadFilters.fileSize(),
						fileUploadFilters.fileType()
					],
					onSuccessItem: function (item, response) {
						item.serverData = response;
					},
					onWhenAddingFileFailed: function(item, filter) {
						var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
						showModalMessage(message);
					}
				},
				fieldData: {
					getUrl: function(item) {
						if ( item.serverData !== undefined ) {
							return Routing.generate('api_upload_get_file', {fileStorage: item.serverData.id});
						}
					}
				}
			});

		return ascentEditModel;
	}

	return formFactory;
});
